// pattern: imperative-shell
import "../styles/main.css";
import { renderSearchPage } from "../components/filter-panel";
import { renderLocationManager } from "../components/location-manager";
import { renderNavBar } from "../components/nav-bar";
import { renderObservationForm } from "../components/observation-form";
import { renderTimeline } from "../components/observation-list";
import { setApiToken } from "./api-client";
import { ensureAuth } from "./auth";
import type { ParsedRoute } from "./router";
import { onRouteChange } from "./router";

const app = document.getElementById("app")!;

// Auth gate
const token = ensureAuth();
setApiToken(token);

// Layout: header + view + nav
app.innerHTML = `
	<header class="header">
		<span id="header-title">Subplot</span>
	</header>
	<main id="view"></main>
	<div id="nav"></div>
`;

const viewEl = document.getElementById("view")!;
const navEl = document.getElementById("nav")!;
const headerTitle = document.getElementById("header-title")!;

const TITLES: Record<string, string> = {
	timeline: "Subplot",
	new: "New Observation",
	edit: "Edit Observation",
	search: "Search",
	locations: "Locations",
};

onRouteChange(async (parsed: ParsedRoute) => {
	headerTitle.textContent = TITLES[parsed.route] ?? "Subplot";
	renderNavBar(navEl, parsed.route);

	switch (parsed.route) {
		case "timeline":
			await renderTimeline(viewEl);
			break;
		case "new":
			await renderObservationForm(viewEl);
			break;
		case "edit":
			await renderObservationForm(viewEl, parsed.params["id"]);
			break;
		case "search":
			await renderSearchPage(viewEl);
			break;
		case "locations":
			await renderLocationManager(viewEl);
			break;
	}
});
